import { createI18n } from 'vue-i18n';

export const i18n = createI18n({
    legacy: false,
    locale: 'en',
    messages: {},
});

/**
 * @param {String} locale
 */
export async function loadMessages(locale) {
    if (Object.keys(i18n.global.getLocaleMessage(locale)).length === 0) {
        let messages;

        if (import.meta.env.MODE === 'test') {
            messages = await import('@/lang/en.json');
        } else {
            messages = await import(/* webpackChunkName: "lang-[request]" */ '@/lang/en.json');
        }

        i18n.global.setLocaleMessage(locale, messages.default);
    }

    if (i18n.locale !== locale) {
        i18n.locale = locale;
    }
}

export default i18n;
